

import { observer } from '@formily/react';
import { ErrorComponent, useConfig } from '@yimoka/react';
import { isSuccess } from '@yimoka/shared';
import { Button, Result, ResultProps, Spin, theme } from 'antd';

import React, { useMemo } from 'react';
import { Link as RLink } from 'react-router-dom';

import { Paragraph } from '../base/typography';
import { Exception } from '../display/exception';
import { useLocaleComponent } from '../hooks/use-locale';

export const ErrorContent: ErrorComponent = observer((props) => {
  const locale = useLocaleComponent('Exception');
  const { returnIndex = true, loading, response, onAgain, icon, status, children, size, trace = 'x-trace-id', ...args } = props;
  const { components } = useConfig();
  const { token } = theme.useToken();


  const success = isSuccess(response);
  const { msg, code, headers } = response;

  const isErr = useMemo(() => ((!loading || (loading && code))) && !success && code, [loading, success, code]);
  const traceID = useMemo(() => trace && headers?.[trace], [headers, trace]);

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Link = useMemo(() => components?.Link ?? RLink, [components]);

  if (!isErr) {
    return null;
  }

  if (size === 'large') {
    const actions = onAgain ? [
      onAgain && <Button key="RETRY_AGAIN" type='primary' onClick={onAgain}>{locale.retry}</Button>,
      returnIndex && <Link key="RETURN_INDEX" to='/'><Button >{locale.backHome}</Button></Link>,
    ] : [
      returnIndex && <Link key="RETURN_INDEX" to='/'><Button type='primary'>{locale.backHome}</Button></Link>,
    ];

    return (
      <Spin spinning={loading}>
        <Exception
          actions={actions}
          desc={
            <>
              <div>{msg}</div>
              {traceID && (
                <Paragraph italic
                  copyable={{ text: traceID }}
                  style={{ marginTop: token.marginSM }}
                  type='secondary'>
                  traceID: {traceID}
                </Paragraph>
              )}
            </>
          }
          title={`${locale.errorTitle} ${code ?? ''}`}
          type={status}
        />
      </Spin>
    );
  }

  const resultProps: ResultProps = {
    ...args,
    icon,
    status,
    title: `${locale.errorTitle} ${code ?? ''}`,
    subTitle: msg,
    extra: <>
      {returnIndex && <Link to='/'><Button >{locale.backHome}</Button></Link>}
      {onAgain && <Button type='primary' onClick={onAgain}>{locale.retry}</Button>}
      {traceID && (
        <Paragraph italic
          copyable={{ text: traceID }}
          style={{ marginTop: token.marginSM }}
          type='secondary'>
          traceID: {traceID}
        </Paragraph>
      )}
    </>,
    children,
  };

  return (
    <Spin spinning={loading}>
      <Result {...resultProps} />
    </Spin>
  );
});
